import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  disconnectCallTrackingProvider,
  getCallTrackingProviders,
} from '@user/store/callTracking'

export function useDisconnectFormikHandler() {
  const dispatch = useAppDispatch()

  const handleDisconnect = useCallback(
    async (callProviderId: number, setStatus: (status?: any) => void) => {
      const result = await dispatch(
        disconnectCallTrackingProvider(callProviderId),
      )

      if (disconnectCallTrackingProvider.fulfilled.match(result)) {
        await dispatch(getCallTrackingProviders())
        setStatus({ error: false, synced: false })
      } else {
        setStatus({
          error: true,
          message: result.payload?.Message,
          synced: true,
        })
      }
    },
    [dispatch],
  )

  return {
    handleDisconnect,
  }
}
